// Posts API Service

export interface Post {
  id: number
  uid: string
  text: string
  post_type: 'post' | 'repost' | 'reply'
  post_created_at: string
  reply_count: number
  repost_count: number
  like_count: number
  quote_count: number
  marked_for_destruction?: boolean
}

export interface PostFilters {
  query?: string
  date_from?: string
  date_till?: string
  day_of_week_mon?: boolean
  day_of_week_tue?: boolean
  day_of_week_wed?: boolean
  day_of_week_thu?: boolean
  day_of_week_fri?: boolean
  day_of_week_sat?: boolean
  day_of_week_sun?: boolean
  reposts?: boolean
  replays?: boolean
  posts?: boolean
  sort_direction?: 'asc' | 'desc'
  sort_by?: 'reply_count' | 'repost_count' | 'like_count' | 'quote_count'
  offset?: number
  limit?: number
}

export async function getPosts(filters: PostFilters = {}): Promise<Post[]> {
  const params = new URLSearchParams()
  
  // Add all filter params
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value))
    }
  })

  const response = await fetch(`/api/v1/secure/bsky/posts?${params.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    credentials: 'include',
  })

  if (!response.ok) {
    throw new Error('Failed to fetch posts')
  }

  return response.json()
}

export async function deletePosts(postIds: number[]): Promise<void> {
  const response = await fetch('/api/v1/secure/bsky/posts/removal', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ ids: postIds }),
  })

  if (!response.ok) {
    throw new Error('Failed to delete posts')
  }
}

export async function reloadPosts(): Promise<void> {
  const response = await fetch('/api/v1/secure/bsky/posts/reload', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    credentials: 'include',
  })

  if (!response.ok) {
    throw new Error('Failed to reload posts')
  }
}

